import { PollingMetricTypeId as PollingMetricTypeId$1, make as make$1, collectAll as collectAll$1, launch as launch$1, poll as poll$1, pollAndUpdate as pollAndUpdate$1, retry as retry$1, zip as zip$1 } from '../../internal/metric/polling.esm.js';

/**
 * @since 2.0.0
 */
/**
 * @since 2.0.0
 * @category symbols
 */
const PollingMetricTypeId = PollingMetricTypeId$1;

/**
 * @since 2.0.0
 * @category symbols
 */

/**
 * A `PollingMetric` is a combination of a metric and an effect that polls for
 * updates to the metric.
 *
 * @since 2.0.0
 * @category models
 */

/**
 * Constructs a new polling metric from a metric and poll effect.
 *
 * @since 2.0.0
 * @category constructors
 */
const make = make$1;

/**
 * Collects all of the polling metrics into a single polling metric, which
 * polls for, updates, and produces the outputs of all individual metrics.
 *
 * @since 2.0.0
 * @category constructors
 */
const collectAll = collectAll$1;

/**
 * Returns an effect that will launch the polling metric in a background
 * fiber, using the specified schedule.
 *
 * @since 2.0.0
 * @category utils
 */
const launch = launch$1;

/**
 * An effect that polls a value that may be fed to the metric.
 *
 * @since 2.0.0
 * @category utils
 */
const poll = poll$1;

/**
 * An effect that polls for a value and uses the value to update the metric.
 *
 * @since 2.0.0
 * @category utils
 */
const pollAndUpdate = pollAndUpdate$1;

/**
 * Returns a new polling metric whose poll function will be retried with the
 * specified retry policy.
 *
 * @since 2.0.0
 * @category constructors
 */
const retry = retry$1;

/**
 * Zips this polling metric with the specified polling metric.
 *
 * @since 2.0.0
 * @category utils
 */
const zip = zip$1;

export { PollingMetricTypeId, collectAll, launch, make, poll, pollAndUpdate, retry, zip };
